import { render } from "./retweet_button.vue?vue&type=template&id=5cc5700f"
import script from "./retweet_button.js?vue&type=script&lang=js"
export * from "./retweet_button.js?vue&type=script&lang=js"

import "./retweet_button.vue?vue&type=style&index=0&id=5cc5700f&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__